export const GenericKeyFileManagerViewType = 'fileManagerViewType';
export const GenericKeyFileManagerShowImageFilenames =
  'GenericKeyFileManagerShowImageFilenames';

export enum FileManagerViewType {
  'oneColumn' = 'oneColumn',
  'twoColumn' = 'twoColumn',
  'grid' = 'grid',
}

export enum FileManagerShowImageFilenames {
  'show' = 'show',
  'hide' = 'hide',
}
